import { CMS_API_BASE } from "../../helper/constants";

export const getDrupalImageUrl = (
  mediaId: string,
  included: any[]
): string | null => {
  if (!mediaId || !included) return null;

  // Find media entity
  const media = included.find(
    (i: any) => i.type === "media--image" && i.id === mediaId
  );
  if (!media) return null;

  const fileId = media?.relationships?.field_media_image?.data?.id;
  if (!fileId) return null;

  // Find file entity
  const file = included.find(
    (i: any) => i.type === "file--file" && i.id === fileId
  );
  if (!file) return null;

  return CMS_API_BASE + file.attributes.uri.url;
};
const cache = new Map<string, any>();

export const fetchWithCacheAndRetry = async (
  url: string,
  retries = 3,
  retryDelay = 1000
) => {
  // ---- Check cache ----
  if (cache.has(url)) {
    return cache.get(url); // instant load
  }

  // ---- Fetch with retry ----
  const attempt = async (count: number): Promise<any> => {
    try {
      const res = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/vnd.api+json",
        },
      });

      if (!res.ok) throw new Error("Network error");

      const json = await res.json();

      cache.set(url, json); // save to cache

      return json;
    } catch (err) {
      if (count <= 0) throw err;

      // Wait & retry
      await new Promise((resolve) => setTimeout(resolve, retryDelay));

      return attempt(count - 1);
    }
  };

  return attempt(retries);
};
const fetchAboutPage = async (uuid: string) => {
  const url = `${CMS_API_BASE}/jsonapi/node/home_page/${uuid}?include=field_featured_image.field_media_image,field_gallery_images.field_media_image`;

  return fetchWithCacheAndRetry(url, 3, 800); 
};
export default fetchAboutPage;





// export const getAboutHero = async () => {
//   const url = `${CMS_API_BASE}/jsonapi/node/home_page/34e71f42-7b59-4d69-b1a6-18c9475ff332?include=field_featured_image.field_media_image,field_gallery_images.field_media_image`;

//   const res = await fetch(url, {
//     headers: {
//       "Content-Type": "application/json",
//       Accept: "application/vnd.api+json",
//     },
//   });

//   if (!res.ok) throw new Error("Failed to fetch Home Page");

//   return res.json();
// };